import PDFViewer from "@documents/components/PDFViewer";
import { Grid2 } from "@mui/material";
import { availableViewportHeight } from "@core/layout/AppLayout";

const UserGuidePage = () => {
    return (
        <Grid2 container size={12} justifyContent={"center"} sx={{ height: availableViewportHeight }}>
            <PDFViewer url={(process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000') + "/files/guideline/Nutzerleitfaden_ESGbot.pdf"} height="100%" />
        </Grid2>
    );
};

export default UserGuidePage;
